"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLookupLocationStateMachine = void 0;
var context_1 = require("./context");
var num_easy_log_1 = require("num-easy-log");
exports.createLookupLocationStateMachine = function () { return new LookupLocationStateMachineImpl(); };
var LookupState;
(function (LookupState) {
    LookupState["indy1"] = "INDY1";
    LookupState["indy2"] = "INDY2";
    LookupState["hosted1"] = "HOSTED1";
    LookupState["hosted2"] = "HOSTED2";
    LookupState["failed"] = "ERROR";
    LookupState["success"] = "SUCCESS";
})(LookupState || (LookupState = {}));
var LookupLocationStateMachineImpl = (function () {
    function LookupLocationStateMachineImpl() {
        this.state = LookupState.indy1;
    }
    LookupLocationStateMachineImpl.prototype.complete = function () {
        return this.state === LookupState.success || this.state === LookupState.failed;
    };
    LookupLocationStateMachineImpl.prototype.step = function (lookupResult) {
        num_easy_log_1.log.debug('LookupLocationStateMachine - before step: ' + this.state);
        var result = typeof lookupResult === 'boolean' && lookupResult === true ? this.success() : this.fail();
        num_easy_log_1.log.debug('LookupLocationStateMachine - after step: ' + this.state);
        return result;
    };
    LookupLocationStateMachineImpl.prototype.success = function () {
        var result;
        switch (this.state) {
            case LookupState.indy1:
            case LookupState.indy2:
                result = context_1.NumLocation.independent;
                break;
            case LookupState.hosted1:
            case LookupState.hosted2:
                result = context_1.NumLocation.hosted;
                break;
            case LookupState.failed:
                result = context_1.NumLocation.none;
                break;
            default:
                result = context_1.NumLocation.populator;
        }
        this.state = LookupState.success;
        return result;
    };
    LookupLocationStateMachineImpl.prototype.fail = function () {
        switch (this.state) {
            case LookupState.indy1:
                this.state = LookupState.hosted1;
                return context_1.NumLocation.hosted;
            case LookupState.hosted1:
            case LookupState.indy2:
            case LookupState.hosted2:
            case LookupState.failed:
                this.state = LookupState.failed;
                return context_1.NumLocation.none;
            default:
                var state = this.state;
                throw new Error("Invalid LookupState status: " + state);
        }
    };
    return LookupLocationStateMachineImpl;
}());
//# sourceMappingURL=lookupstatemachine.js.map